module.exports = __webpack_public_path__ + "static/media/icon-howto.f4f538dc.svg";